import { render, staticRenderFns } from "./SolicitorSummary.vue?vue&type=template&id=23314cf0"
import script from "./SolicitorSummary.vue?vue&type=script&lang=js"
export * from "./SolicitorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports